import React from 'react';
import CircleMinus from 'assets/icons/circle-minus.svg';
import CirclePlus from 'assets/icons/circle-plus.svg';
import styles from './ToggleButton.module.css';
type ToggleButtonProps = {
  isOpen: boolean;
  toggle: () => void;
};
const ToggleButton = ({
  isOpen,
  toggle
}: ToggleButtonProps, ref: React.Ref<HTMLButtonElement>) => {
  const dataTrk = isOpen ? 'series-banner-toggle-open' : 'series-banner-toggle-closed';
  return <button aria-expanded={isOpen} className={styles.toggleButton} data-trk={dataTrk} onClick={() => toggle()} ref={ref} type="button" data-sentry-component="ToggleButton" data-sentry-source-file="ToggleButton.tsx">
      <span className={styles.buttonText}>Om serien</span>
      {isOpen ? <CircleMinus focusable="false" /> : <CirclePlus focusable="false" />}
    </button>;
};
export default React.forwardRef(ToggleButton);